import { RECEIVE_QUOTATIONS, UPDATE_QUOTATIONS_FILTERS, FAILURE_QUOTATIONS, UNLOAD_QUOTATIONS, REQUEST_QUOTATIONS } from '../constants/action_types';
import { fetchQuotations } from '../api/api';
import * as schema from '../../../data/followup/api/schema';
import moment from 'moment'
import {normalize} from "normalizr";
import {arrayOfReservations} from "../../followup/api/schema";


const receiveQuotations = (data, reset) => ({
    type: RECEIVE_QUOTATIONS,
    data,
    reset
});

const failureQuotations = () => ({
    type: FAILURE_QUOTATIONS,
});


const updateFilters = (filters) => dispatch => {
    dispatch({
        type: UPDATE_QUOTATIONS_FILTERS,
        filters
    })
    dispatch(requestQuotations(true));
}


const requestQuotations = (reset = false) => (dispatch, getState) => {

    const {isFetching, reachedEnd} = getState().account.quotation;
    if (!isFetching && !reachedEnd) {
        const {filters, nextPage} = getState().account.quotation;

        let from = filters.date.from ? moment(filters.date.from).format() : "";
        let to = filters.date.to ? moment(filters.date.to).format() : filters.date.from ? moment(filters.date.from).add(1, "days").format(): "";
        let status = filters.status== null ? [] : filters.status;

        let normalizedFilters = {
            "query": filters.query,
            "from": from,
            "to": to,
            "routes": filters.route,
            "status": status
        }

        dispatch({
            type: REQUEST_QUOTATIONS,
            reset
        })
        return fetchQuotations(normalizedFilters, nextPage)
            .then(response => response.json())
            .then(json => normalize(json, schema.arrayOfReservations))
            .then(data => dispatch(receiveQuotations(data, reset)))
            .catch(error => {
                console.log(error);
                return dispatch(failureQuotations());
            });
    }
}

const unloadQuotations = () => ({
    type: UNLOAD_QUOTATIONS,
})







export {
    updateFilters,
    requestQuotations,
    unloadQuotations
};
